import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoneColorForm from '../../../../components/masters/stoneAttribute/stoneColor/StoneColorForm';
import StoneColorTable from '../../../../components/masters/stoneAttribute/stoneColor/StoneColorTable';
import { fetchStoneColors, addStoneColor, updateStoneColor, deleteStoneColor, setStoneColorEdit, clearStoneColorEdit } from '../../../../redux/actions/masters/stoneAttribute/stoneColor/stoneColorAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .stone-color-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .stone-color-form, .stone-color-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const StoneColorPage = () => {
  const dispatch = useDispatch();  const { list = [], loading, editingStoneColor, formSuccess, formError } = useSelector(state => state.stoneColor || {});

  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchStoneColors());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearStoneColorEdit());
  };

  const handleSubmit = async (form) => {
    if (editingStoneColor && editingStoneColor.stone_color_id) {
      await dispatch(updateStoneColor(editingStoneColor.stone_color_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addStoneColor(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (stoneColor) => {
    dispatch(setStoneColorEdit(stoneColor));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteStoneColor(id));
  };

  const handleCancel = () => {
    dispatch(clearStoneColorEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      sc => sc.stone_color_code === code && (!excludeId || sc.stone_color_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="stone-color-flex">
        <div style={tableContainer} className="stone-color-table">
          <StoneColorTable
            onNew={handleFormReset}
            stoneColors={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="stone-color-form">
          <StoneColorForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingStoneColor={editingStoneColor}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default StoneColorPage; 